export default "__VITE_ASSET__eb4a761e__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2952923__"